// Traductions du mode Lite : page de détails d'un compte. Les libellés métier
// (règles, payouts, stats) viennent de `tradingAccounts`, partagés avec l'Advanced.
export const fr = {
  back: "Comptes",
  balance: "Solde",
  sinceStart: "depuis le départ",
  objectiveProfit: "Profit compté pour l'objectif",
  objectiveProfitHint: "Le chiffre qui décide de la validation, aligné sur le relevé de la prop firm.",
  progress: "Où tu en es",
  done: "Atteint",
  remaining: "restant",
  performance: "Performance",
  balanceCurve: "Évolution du solde",
  start: "Départ",
  floor: "Plancher",
  rules: "Règles du compte",
  symbols: "Par symbole",
  sync: "Synchronisation",
  notFound: "Compte introuvable",
};

export const en: typeof fr = {
  back: "Accounts",
  balance: "Balance",
  sinceStart: "since start",
  objectiveProfit: "Profit counted toward the target",
  objectiveProfitHint: "The number that decides the evaluation, matching the prop firm's statement.",
  progress: "Where you stand",
  done: "Reached",
  remaining: "left",
  performance: "Performance",
  balanceCurve: "Balance over time",
  start: "Start",
  floor: "Floor",
  rules: "Account rules",
  symbols: "By symbol",
  sync: "Sync",
  notFound: "Account not found",
};
